import React, { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LazyDynamicImport from "./components/lazy-dynamic-import";
import patientPageData from "./patientPageData";
import hcpPageData from "./hcpPageData";
import DefaultLayout from "../layouts/default-layout";
import HcpLayout from "../layouts/hcp-layout";
import LazyDynamicImportLoader from "./components/lazy-dynamic-import-loader";
import PageHelmet from "../components/page-helmet";
import AutoScrollTop from "../components/auto-scroll-top";

function Router() {

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<DefaultLayout />}>
          {patientPageData.map(({name, path}) => {
            const paths = Array.isArray(path) ? path : [path];

            return paths.map((singlePath) => {
              return (
                <Route
                  key={`route_${name}`}
                  path={singlePath}
                  element={
                    <PageHelmet pageName={name}>
                      <AutoScrollTop />
                      <Suspense fallback={<LazyDynamicImportLoader />}>
                        {LazyDynamicImport(name)}
                      </Suspense>
                    </PageHelmet>
                  }
                />
              )})}
          )}
        </Route>
        <Route element={<HcpLayout />}>
          {hcpPageData.map(({name, path}) => {
            const paths = Array.isArray(path) ? path : [path];

            return paths.map((singlePath) => {
              return (
                <Route
                  key={`route_${name}`}
                  path={singlePath}
                  element={
                    <PageHelmet pageName={name}>
                      <AutoScrollTop />
                      <Suspense fallback={<LazyDynamicImportLoader />}>
                        {LazyDynamicImport(name)}
                      </Suspense>
                    </PageHelmet>
                  }
                />
              )})}
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default Router;